import { API_BASE_URL as BASE_URL } from "sushi/config";
import { CHAIN_ID } from "./chain-id";

export const API_BASE_URL = CHAIN_ID === 33111 ? "https://staging.sushi.com" : BASE_URL;
